var E={ESCAPE:27,SPACE:32,ENTER:13,TAB:9,UP:38,RIGHT:39,DOWN:40,LEFT:37};export{E as K};
//# sourceMappingURL=key-codes-9d26881a.js.map
